import type { ComponentProps } from "react";

import { translate } from "app/filters/i18nFilter";
import type { SearchResultsTableWithTrialHook } from "app/pages/sales-intelligence/common-components/search-results-table";

export const COMPETITORS_TRIAL_HOOK_PROPS: ComponentProps<typeof SearchResultsTableWithTrialHook>["trialHookProps"] = {
    trackingEventName: "competitors hook",
    get title() {
        return translate("si.company-analysis.competitors.trial-overlay-hook.title");
    },
    get subTitle() {
        return translate("si.company-analysis.competitors.trial-overlay-hook.subtitle");
    },
};
